<script setup lang="ts">
import { MContainerColumn } from "@xlabmedical/medic-web-framework";

const label = defineModel<string>("label", { required: true });
const value = defineModel<string>("value", { required: false, default: "-" });
const color = defineModel<string>("color", { required: false, default: undefined });
</script>

<template>
    <MContainerColumn class="align-center gap-1 grow justify-center w-full" style="align-items: baseline">
        <span class="grid-item-label justify-center w-full" style="display: none">{{ label }}</span>
        <span v-if="color" class="flex flex-row-wrap gap-2 items-center w-full">
            <span :style="`background-color: ${color} !important; `" class="transparent-dot" />
            <span>{{ value }}</span>
        </span>
        <span v-else>{{ value }}</span>
    </MContainerColumn>
</template>

<style scoped></style>
